import { z } from "zod";
/** Explicit, organisation-owned synthetic source. Never an OAuth alternative. */
export const googleEmulatorConfigSchema = z.object({
    connectorKind: z.literal("emulator"),
    apiBaseUrl: z.string().url().refine((value) => {
        const url = new URL(value);
        return url.protocol === "http:" && url.hostname === "127.0.0.1"
            && value === url.origin && !url.username && !url.password;
    }, "Emulator must use an exact loopback HTTP origin"),
    fixtureSha256: z.string().regex(/^[a-f0-9]{64}$/u),
}).strict();
export function isGoogleEmulatorKind(provider, kind) {
    return (provider === "gmail" || provider === "google_calendar") && kind === "emulator";
}
export function requireGoogleEmulatorOrigin(config, allowedOrigins) {
    const { apiBaseUrl } = googleEmulatorConfigSchema.parse(config);
    if (!(allowedOrigins ?? "").split(",").map(value => value.trim()).includes(apiBaseUrl)) {
        throw new Error("Google emulator origin is not operator allow-listed");
    }
    return apiBaseUrl;
}
